import { PocList } from 'commons/components/components-wrapper/poc-list.component';
import { SideMenuListItem } from 'layout';
import { useDeviceConfigurationLayout } from 'modules/settings/contexts/device-configuration/hooks/use-device-configuration-layout.hook';
import { useDeviceConfiguration } from 'modules/settings/contexts/device-configuration/hooks/use-device-configuration.hook';
import { PROPERTY_STATUS } from '../constants';
import { DeviceLayoutConfigSection } from '../settings-devices-configuration-layout.model';
import { SettingsDevicesConfigurationLeftMenuStyled } from '../settings-devices-configuration.style';

export const SettingsDeviceConfigurationLeftMenu: React.FC = () => {
    const { layoutSections, layoutSectionSelected, setLayoutSectionSelected } = useDeviceConfigurationLayout();
    const { isSectionDisabled, isSectionHidden } = useDeviceConfiguration();

    const handleSectionClick = (sectionId: string) => {
        const sectionSelected = layoutSections?.sections.find((s) => s.id === sectionId);

        if (!sectionSelected) {
            return;
        }

        if (sectionSelected.hasHeaders) {
            setLayoutSectionSelected?.(sectionSelected.id);
            return;
        }

        if (sectionSelected.subSections.length > 0) {
            const firstSubsection = sectionSelected.subSections.toSorted(
                (a: DeviceLayoutConfigSection, b: DeviceLayoutConfigSection) => a.order - b.order
            )[0];
            setLayoutSectionSelected?.(firstSubsection.id);
            return;
        }

        setLayoutSectionSelected?.(sectionSelected.id);
    };

    const handleSubsectionClick = (subSectionId: string) => {
        setLayoutSectionSelected?.(subSectionId);
    };

    return (
        <SettingsDevicesConfigurationLeftMenuStyled className="sidemenu">
            <PocList variant="side-menu" size="medium" selected={[layoutSectionSelected ?? '']}>
                {layoutSections?.sections
                    .sort((a, b) => a.order - b.order)
                    .filter((section) => !isSectionHidden(section.name) && section.status !== PROPERTY_STATUS.HIDDEN)
                    .map((section) => (
                        <SideMenuListItem
                            key={section.id}
                            data-testid={`config-menu-item-${section.id}`}
                            value={section.id}
                            disabled={isSectionDisabled(section.name) ?? section.status === PROPERTY_STATUS.DISABLED}
                            selected={layoutSectionSelected === section.id}
                            expanded={
                                layoutSectionSelected === section.id ||
                                section.subSections.some((sub) => sub.id === layoutSectionSelected)
                            }
                            onClick={(ev) => {
                                if ((ev.target as HTMLElement).closest('owc-icon-button')) {
                                    return;
                                }
                                ev.stopPropagation();
                                handleSectionClick(section.id);
                            }}
                        >
                            {section.displayName}

                            {section.subSections.length > 0 && (
                                <PocList slot="children">
                                    {section.subSections
                                        .toSorted((a, b) => a.order - b.order)
                                        .map((subSection) => (
                                            <SideMenuListItem
                                                key={subSection.id}
                                                data-testid={`config-menu-item-${subSection.id}`}
                                                value={subSection.id}
                                                disabled={
                                                    isSectionDisabled(subSection.name) ??
                                                    subSection.status === PROPERTY_STATUS.DISABLED
                                                }
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    handleSubsectionClick(subSection.id);
                                                }}
                                            >
                                                {subSection.displayName}
                                            </SideMenuListItem>
                                        ))}
                                </PocList>
                            )}
                        </SideMenuListItem>
                    ))}
            </PocList>
        </SettingsDevicesConfigurationLeftMenuStyled>
    );
};
